const colors = {
  300: "#F2A0C5",
  500: "#EE7DB0",
  700: "#AE5B81",
};

export default colors;
